module.exports = __webpack_public_path__ + "media/application/images/2018/fav-green-star-90349bf3398fcdb9da8b17b7293ddc19.svg";